export default "__VITE_ASSET__Dhzj8XNZ__"